export const CARD_WIDTH = 300;
export const V_PADDING = 10;
export const H_PADDING = 15;
export const EDGE_MARGIN = 10;

export function getPosition(
  el: HTMLDivElement,
  container: HTMLElement
): [
  coords: {left: number; top: number},
  flipped: boolean,
  container: HTMLElement
] {
  const {left: x, top: y, width} = el.getBoundingClientRect();
  const {left: cx, top: cy, width: cwidth} = container.getBoundingClientRect();
  let flipped = false;

  // the card doesn't fit on the container
  if (CARD_WIDTH + EDGE_MARGIN > cwidth && container != document.body) {
    // so let's use ALL the space available trying to fit it in
    return getPosition(el, document.body);
  }

  // align the card using avatar position, so the card avatar will appear exactly
  // over the target avatar
  let coords = {
    left: x - cx + container.scrollLeft - H_PADDING,
    top: y - cy + container.scrollTop - V_PADDING,
  };

  // calculate if the card is leaking outside the container
  const pixelsOverflow = coords.left + CARD_WIDTH + EDGE_MARGIN - cwidth;

  // oh no, the card is leaking from the container
  if (pixelsOverflow > 0) {
    // simulate flipped position
    const flippedLeft = coords.left + H_PADDING * 2 - CARD_WIDTH + width;

    // if there's space for a flipped card, let's flip it!
    if (flippedLeft > EDGE_MARGIN) {
      flipped = true;
      coords.left = flippedLeft;
    } else {
      // adjust card position to not overflow, it wont fit exactly over the target avatar
      // but that's ok
      coords.left -= pixelsOverflow + EDGE_MARGIN;
    }
  }

  // ensure the card left side won't overflow
  if (coords.left < EDGE_MARGIN) {
    coords.left = EDGE_MARGIN;
  }

  return [coords, flipped, container];
}
